<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <KTCodePreview v-bind:title="'Thông tin lịch sử hoá đơn'">
          <template v-slot:preview>
            <b-container class="bv-example-row">
              <b-row class="justify-content-md-center mb-10">
                <b-col cols="6">
                  <b-row>
                    <b-col class="col-md-3">
                      <p class="header-color">Mã hoá đơn:</p>
                      <p class="header-color">Loại thao tác:</p>
                    </b-col>
                    <b-col class="col-md-9">
                      <p>{{ orderId }}</p>
                      <p :class="getHistoryActionClass(action)">
                        {{ getHistoryActionName(action) }}
                      </p>
                    </b-col>
                  </b-row>
                </b-col>

                <b-col cols="6">
                  <b-row>
                    <b-col class="col-md-3">
                      <p class="header-color">Người thao tác:</p>
                    </b-col>
                    <b-col class="col-md-9">
                      <p>{{ createdByName }}</p>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-container>

            <div>
              <h5 class="bold-text">Thông tin chỉnh sửa đơn hàng</h5>
              <hr />
              <b-container class="bv-example-row">
                <table
                  border="1"
                  style="width: 60%"
                  class="table table-bordered table-vertical-center table-hover mb-10"
                >
                  <colgroup>
                    <col style="width: 20%" />
                    <col style="width: 40%" v-if="isActionUpdate" />
                    <col style="width: 40%" />
                  </colgroup>
                  <thead class="bg-secondary">
                    <tr>
                      <th rowspan="2">Dữ liệu</th>
                    </tr>
                    <tr>
                      <th v-if="isActionUpdate">Thông tin cũ</th>
                      <th>Thông tin mới</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="originalValue.storeId !== newValue.storeId">
                      <td>Cửa hàng</td>
                      <th v-if="isActionUpdate">
                        {{ getStoreName(originalValue.storeId) }}
                      </th>
                      <td v-if="stores.length > 0">
                        {{ getStoreName(newValue.storeId) }}
                      </td>
                    </tr>
                    <tr
                      v-if="
                        originalValue.orderSourceId !== newValue.orderSourceId
                      "
                    >
                      <td>Nguồn đơn hàng</td>
                      <th v-if="isActionUpdate">
                        {{ getOrderSourceName(originalValue.orderSourceId) }}
                      </th>
                      <td v-if="orderSources.length > 0">
                        {{ getOrderSourceName(newValue.orderSourceId) }}
                      </td>
                    </tr>
                    <tr v-if="originalValue.orderType !== newValue.orderType">
                      <td>Loại đơn</td>
                      <th v-if="isActionUpdate">
                        {{ getOrderTypeName(originalValue.orderType) }}
                      </th>
                      <td v-if="orderSources.length > 0">
                        {{ getOrderTypeName(newValue.orderType) }}
                      </td>
                    </tr>
                    <tr v-if="originalValue.status !== newValue.status">
                      <td>Trạng thái đơn</td>
                      <th v-if="isActionUpdate">
                        {{ getOrderStatusName(originalValue.status) }}
                      </th>
                      <td v-if="orderSources.length > 0">
                        {{ getOrderStatusName(newValue.status) }}
                      </td>
                    </tr>
                    <tr v-if="originalValue.checkDate !== newValue.checkDate">
                      <td>Ngày đến cửa hàng</td>
                      <th v-if="isActionUpdate">
                        {{ originalValue.checkDate }}
                      </th>
                      <td v-if="orderSources.length > 0">
                        {{ newValue.checkDate }}
                      </td>
                    </tr>
                    <tr v-if="originalValue.checkTime !== newValue.checkTime">
                      <td>Giờ đến cửa hàng</td>
                      <th v-if="isActionUpdate">
                        {{ originalValue.checkTime }}
                      </th>
                      <td v-if="orderSources.length > 0">
                        {{ newValue.checkTime }}
                      </td>
                    </tr>
                    <tr
                      v-if="
                        originalValue.customerName !== newValue.customerName
                      "
                    >
                      <td>Tên khách hàng</td>
                      <th v-if="isActionUpdate">
                        {{ originalValue.customerName }}
                      </th>
                      <td v-if="orderSources.length > 0">
                        {{ newValue.customerName }}
                      </td>
                    </tr>
                    <tr
                      v-if="
                        originalValue.customerMobile !== newValue.customerMobile
                      "
                    >
                      <td>SĐT khách hàng</td>
                      <th v-if="isActionUpdate">
                        {{ originalValue.customerMobile }}
                      </th>
                      <td v-if="orderSources.length > 0">
                        {{ newValue.customerMobile }}
                      </td>
                    </tr>
                    <tr
                      v-if="
                        originalValue.customerAddress !==
                        newValue.customerAddress
                      "
                    >
                      <td>Địa chỉ khách hàng</td>
                      <th v-if="isActionUpdate">
                        {{ originalValue.customerAddress }}
                      </th>
                      <td v-if="orderSources.length > 0">
                        {{ newValue.customerAddress }}
                      </td>
                    </tr>
                    <tr v-if="originalValue.codeShip !== newValue.codeShip">
                      <td>Mã vận đơn</td>
                      <th v-if="isActionUpdate">
                        {{ originalValue.codeShip }}
                      </th>
                      <td v-if="orderSources.length > 0">
                        {{ newValue.codeShip }}
                      </td>
                    </tr>
                    <tr v-if="originalValue.saleNote !== newValue.saleNote">
                      <td>Ghi chú CSKH</td>
                      <th v-if="isActionUpdate">
                        {{ originalValue.saleNote }}
                      </th>
                      <td v-if="orderSources.length > 0">
                        {{ newValue.saleNote }}
                      </td>
                    </tr>
                    <tr
                      v-if="
                        originalValue.customerNote !== newValue.customerNote
                      "
                    >
                      <td>Ghi chú của khách</td>
                      <th v-if="isActionUpdate">
                        {{ originalValue.customerNote }}
                      </th>
                      <td v-if="orderSources.length > 0">
                        {{ newValue.customerNote }}
                      </td>
                    </tr>
                    <tr
                      v-if="
                        originalValue.warrantyNote !== newValue.warrantyNote
                      "
                    >
                      <td>Ghi chú bảo hành</td>
                      <th v-if="isActionUpdate">
                        {{ originalValue.warrantyNote }}
                      </th>
                      <td v-if="orderSources.length > 0">
                        {{ newValue.warrantyNote }}
                      </td>
                    </tr>
                    <tr v-if="originalValue.couponCode !== newValue.couponCode">
                      <td>Mã coupon</td>
                      <th v-if="isActionUpdate">
                        {{ originalValue.couponCode }}
                      </th>
                      <td v-if="orderSources.length > 0">
                        {{ newValue.couponCode }}
                      </td>
                    </tr>
                    <tr
                      v-if="
                        originalValue.discountAmount !== newValue.discountAmount
                      "
                    >
                      <td>Chiết khấu</td>
                      <th v-if="isActionUpdate">
                        {{ originalValue.discountAmount }}
                      </th>
                      <td v-if="orderSources.length > 0">
                        {{ newValue.discountAmount || 0 }}
                      </td>
                    </tr>
                    <tr
                      v-if="
                        originalValue.depositAmount !== newValue.depositAmount
                      "
                    >
                      <td>Tiền đặt cọc</td>
                      <th v-if="isActionUpdate">
                        {{ originalValue.depositAmount || 0 }}
                      </th>
                      <td v-if="orderSources.length > 0">
                        {{ newValue.depositAmount || 0 }}
                      </td>
                    </tr>
                    <tr
                      v-if="
                        originalValue.transferAmount !== newValue.transferAmount
                      "
                    >
                      <td>Tiền chuyển khoản</td>
                      <th v-if="isActionUpdate">
                        {{ originalValue.transferAmount }}
                      </th>
                      <td v-if="orderSources.length > 0">
                        {{ newValue.transferAmount }}
                      </td>
                    </tr>
                    <tr v-if="originalValue.cardAmount !== newValue.cardAmount">
                      <td>Tiền quẹt thẻ</td>
                      <th v-if="isActionUpdate">
                        {{ originalValue.cardAmount || 0 }}
                      </th>
                      <td v-if="orderSources.length > 0">
                        {{ newValue.cardAmount || 0 }}
                      </td>
                    </tr>
                    <tr
                      v-if="
                        originalValue.installmentAmount !==
                        newValue.installmentAmount
                      "
                    >
                      <td>Tiền trả góp</td>
                      <th v-if="isActionUpdate">
                        {{ newValue.installmentAmount || 0 }}
                      </th>
                      <td v-if="orderSources.length > 0">
                        {{ newValue.installmentAmount || 0 }}
                      </td>
                    </tr>
                    <tr
                      v-if="
                        originalValue.refundAmount !== newValue.refundAmount
                      "
                    >
                      <td>Hoàn tiền</td>
                      <th v-if="isActionUpdate">
                        {{ newValue.refundAmount || 0 }}
                      </th>
                      <td>
                        {{ newValue.refundAmount || 0 }}
                      </td>
                    </tr>
                    <tr
                      v-if="originalValue.totalAmount !== newValue.totalAmount"
                    >
                      <td>Tổng tiền hoá đơn</td>
                      <th v-if="isActionUpdate">{{ newValue.totalAmount }}</th>
                      <td v-if="orderSources.length > 0">
                        {{ newValue.totalAmount }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-container>
              <h5 class="bold-text">Chi tiết thay đổi sản phẩm</h5>
              <hr />
              <b-container class="bv-example-row">
                <table
                  class="table table-bordered table-vertical-center table-hover mb-10"
                >
                  <tr>
                    <th>Trước</th>
                    <th>Sau</th>
                  </tr>
                  <tr v-for="(item, index) in orderItems" :key="index">
                    <td
                      class="w-50"
                      v-if="isItemChanged(item.originalValue, item.newValue)"
                    >
                      <div>
                        <span>
                          <b-row>
                            <b-col class="col col-sm-3">
                              <p class="header-color">ID sản phẩm:</p>
                              <p class="header-color">Tên sản phẩm:</p>
                              <p class="header-color">Loại:</p>
                              <p class="header-color">Giá:</p>
                              <p class="header-color">Số lượng:</p>
                              <p class="header-color">Chiết khấu:</p>
                            </b-col>
                            <b-col
                              v-if="
                                item.originalValue &&
                                Object.keys(item.originalValue).length !== 0
                              "
                            >
                              <p>{{ item.originalValue.productId }}</p>
                              <p>{{ item.originalValue.productName || '-' }}</p>
                              <p
                                v-if="
                                  item.originalValue.productType ===
                                  PRODUCT_TYPE_ENUM.CHASSIS_ENGINE
                                "
                                style="font-style: italic"
                                class="font-size-gift d-flex mb-2"
                              >
                                <span
                                  @click="
                                    goToProductChassis(
                                      item.originalValue.productChassisId,
                                    )
                                  "
                                  class="text-primary cursor-pointer font-size-print"
                                  >SK, SM:
                                  {{ item.originalValue.productChassisId }}
                                  &nbsp;</span
                                >
                              </p>
                              <p
                                v-if="
                                  item.originalValue.productType ===
                                  PRODUCT_TYPE_ENUM.SERIES
                                "
                                style="font-style: italic"
                                class="font-size-gift mt-2"
                              >
                                <span
                                  @click="
                                    goToProductSerial(
                                      item.originalValue.productSerialId,
                                    )
                                  "
                                  class="text-primary cursor-pointer font-size-print"
                                  >SERI:
                                  {{ item.originalValue.productSerialId }}
                                  &nbsp;</span
                                >
                              </p>
                              <p
                                v-if="
                                  item.originalValue.productType !==
                                    PRODUCT_TYPE_ENUM.CHASSIS_ENGINE &&
                                  item.originalValue.productType !==
                                    PRODUCT_TYPE_ENUM.SERIES
                                "
                                class="placeholder-space"
                              ></p>

                              <p>{{ item.originalValue.productPrice || 0 }}</p>
                              <p>{{ item.originalValue.quantity }}</p>
                              <p>
                                {{ item.originalValue.discountAmount || 0 }}
                              </p>
                            </b-col>
                          </b-row>
                        </span>
                      </div>
                    </td>
                    <td
                      class="w-50"
                      v-if="isItemChanged(item.originalValue, item.newValue)"
                    >
                      <div>
                        <span>
                          <b-row>
                            <b-col class="col col-sm-3">
                              <p class="header-color">ID sản phẩm:</p>
                              <p class="header-color">Tên sản phẩm:</p>
                              <p class="header-color">Loại:</p>
                              <p class="header-color">Giá:</p>
                              <p class="header-color">Số lượng:</p>
                              <p class="header-color">Chiết khấu:</p>
                            </b-col>
                            <b-col
                              v-if="
                                item.newValue &&
                                Object.keys(item.newValue).length !== 0
                              "
                            >
                              <p>{{ item.newValue.productId }}</p>
                              <p>{{ item.newValue.productName || '-' }}</p>
                              <p
                                v-if="
                                  item.newValue.productType ===
                                  PRODUCT_TYPE_ENUM.CHASSIS_ENGINE
                                "
                                style="font-style: italic"
                                class="font-size-gift d-flex mb-2"
                              >
                                <span
                                  @click="
                                    goToProductChassis(
                                      item.newValue.productChassisId,
                                    )
                                  "
                                  class="text-primary cursor-pointer font-size-print"
                                  >SK, SM:
                                  {{ item.newValue.productChassisId }}
                                  &nbsp;</span
                                >
                              </p>
                              <p
                                v-if="
                                  item.newValue.productType ===
                                  PRODUCT_TYPE_ENUM.SERIES
                                "
                                style="font-style: italic"
                                class="font-size-gift mt-2"
                              >
                                <span
                                  @click="
                                    goToProductSerial(
                                      item.newValue.productSerialId,
                                    )
                                  "
                                  class="text-primary cursor-pointer font-size-print"
                                  >SERI:
                                  {{ item.newValue.productSerialId }}
                                  &nbsp;</span
                                >
                              </p>
                              <p
                                v-if="
                                  item.originalValue.productType !==
                                    PRODUCT_TYPE_ENUM.CHASSIS_ENGINE &&
                                  item.originalValue.productType !==
                                    PRODUCT_TYPE_ENUM.SERIES
                                "
                                class="placeholder-space"
                              ></p>
                              <p>{{ item.newValue.productPrice || 0 }}</p>
                              <p>{{ item.newValue.quantity }}</p>
                              <p>{{ item.newValue.discountAmount || 0 }}</p>
                            </b-col>
                          </b-row>
                        </span>
                      </div>
                    </td>
                  </tr>
                </table>
              </b-container>
            </div>
          </template>
          <template v-slot:foot>
            <router-link to="/order-history" tag="button">
              <b-button
                style="font-weight: 600; width: 70px"
                variant="secondary"
                size="sm"
                >Hủy</b-button
              >
            </router-link>
          </template>
        </KTCodePreview>
      </div>
    </div>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import ApiService from '@/core/services/api.service';
import {
  ORDER_HISTORY_ACTION_CONST,
  ORDER_TYPE,
  ORDER_STATUS,
} from '@/utils/constants';
import { ORDER_HISTORY_ACTION_ENUM, PRODUCT_TYPE_ENUM } from '@/utils/enum';

export default {
  data() {
    return {
      ORDER_HISTORY_ACTION_ENUM,
      PRODUCT_TYPE_ENUM,
      id: '',
      action: '',
      orderId: '',
      createdByName: '',
      storeName: '',
      diffInfo: {},
      originalValue: {},
      newValue: {},
      diffItem: {},
      clientIp: '',
      stores: [],
      orderSources: [],
      orderItems: [],
    };
  },
  components: {
    KTCodePreview,
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Lịch sử đơn hàng', route: '/order-history' },
      { title: 'Chi tiết lịch sử đơn hàng', route: '/detail-order-history' },
    ]);

    this.id = this.$route.query.id;
  },
  created() {
    this.getDetailHistory();
    this.fetchStores();
    this.fetchOrderSources();
  },
  computed: {
    isActionUpdate() {
      return this.action === ORDER_HISTORY_ACTION_ENUM.UPDATE;
    },
    isActionInsert() {
      return this.action === ORDER_HISTORY_ACTION_ENUM.CREATE;
    },
  },
  methods: {
    goToProductChassis(productId) {
      const { href } = this.$router.resolve({
        name: 'list-chassis-engine',
        query: { searchId: productId },
      });

      return window.open(href, '_blank');
    },
    goToProductSerial(productId) {
      const { href } = this.$router.resolve({
        name: 'list-serial',
        query: { searchId: productId },
      });

      return window.open(href, '_blank');
    },
    async fetchOrderSources() {
      await ApiService.query('/order-sources', {
        params: { getFull: true },
      }).then((response) => {
        this.orderSources = response.data.data;
      });
    },
    async fetchStores() {
      await ApiService.query('/stores', {
        params: { getFull: true },
      }).then((response) => {
        this.stores = response.data.data;
      });
    },
    getStoreName(storeId) {
      if (!storeId) return '';
      return this.stores.find((store) => store.id === storeId)?.name;
    },
    getOrderSourceName(orderSourceId) {
      if (!orderSourceId) return '';
      return this.orderSources.find(
        (orderSource) => orderSource.id === orderSourceId,
      )?.name;
    },
    getOrderTypeName(orderTypeId) {
      if (!orderTypeId) return '';
      return ORDER_TYPE.find((orderType) => orderType.id === orderTypeId)?.name;
    },
    convertPrice: function (number) {
      let result = new Intl.NumberFormat('vn-VN').format(number);
      return isNaN(parseFloat(result)) ? '' : result;
    },
    setCurrentAddedObj(obj) {
      let result = JSON.parse(obj);
      return result;
    },
    isModified(value) {
      return value === 'MODIFIED';
    },
    isAdded(value) {
      return value === 'ADDED';
    },
    getHistoryActionName(action) {
      if (!action) return '';
      return ORDER_HISTORY_ACTION_CONST.find((x) => x.value === action).text;
    },
    getHistoryActionClass(action) {
      switch (action) {
        case ORDER_HISTORY_ACTION_ENUM.CREATE:
          return 'label font-weight-bold label-lg label-light-success label-inline';
        case ORDER_HISTORY_ACTION_ENUM.UPDATE:
          return 'label font-weight-bold label-lg label-light-warning label-inline';
        case ORDER_HISTORY_ACTION_ENUM.DELETE:
          return 'label font-weight-bold label-lg label-light-danger label-inline';
        default:
          return '';
      }
    },
    getOrderStatusName(status) {
      if (!status) return '';
      return ORDER_STATUS.find((orderStatus) => orderStatus.value == status)
        ?.text;
    },
    getDetailHistory: async function () {
      await ApiService.setHeader();
      await ApiService.query('/order-histories/' + this.id).then((res) => {
        let {
          action,
          orderId,
          creator,
          storeName,
          diffInfo,
          originalValue,
          newValue,
          orderItems,
          diffItem,
          clientIp,
        } = res.data.data;
        this.action = action;
        this.orderId = orderId;
        this.createdByName = creator.fullName;
        this.storeName = storeName;
        this.clientIp = clientIp;
        this.diffInfo = diffInfo;
        this.newValue = newValue;
        this.orderItems = orderItems;
        this.originalValue = originalValue;
        this.diffItem = diffItem;
      });
    },
    isItemChanged(originalValue, newValue) {
      if (!originalValue || !newValue) return true;

      const fieldsToCompare = [
        'productId',
        'productChassisId',
        'productSerialId',
        'orderItemProductType',
        'productPrice',
        'quantity',
        'discountAmount',
      ];

      return fieldsToCompare.some(
        (field) => originalValue[field] !== newValue[field],
      );
    },
  },
};
</script>

<style>
.header-color {
  font-weight: 500;
}

.bold-text {
  color: #212121;
}
.placeholder-space {
  height: 1em;
  visibility: hidden;
}
</style>
